<template>
  <v-text-field
    v-if="!isInternetExplorer"
    :outlined="!disabled"
    :filled="disabled"
    :value="inputValue"
    :label="label"
    :hint="hint"
    :hide-details="'auto'"
    @input="emitValue"
    :rules="rules"
    :disabled="disabled || hiddenData"
    v-bind:class="{ 'hiddenData': hiddenData }"
  >
   <template v-if="$slots.required" v-slot:prepend-inner>
      <slot name="required"></slot>
    </template>

    <template v-if="canHideData || canDeleteData || canCopyData" v-slot:append>
      <v-btn
        v-if="canHideData"
        class="button-eye"
        icon
        @click="toggleHiddenData"
      >
        <v-icon>{{ hiddenData ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
      </v-btn>

      <v-btn
        v-if="canDeleteData && deletedData && visibleValue !== ''"
        class="button-delete"
        icon
        @click="deleteFieldData"
      >
        <v-icon>{{ deletedData ? 'mdi-delete' : '' }}</v-icon>
      </v-btn>

      <v-btn
        v-if="canCopyData && !deletedData && visibleValue === '' "
        class="button-copy"
        icon
        @click="copyFieldData"
      >
        <v-icon>{{ copiedData ? 'mdi-content-copy' : '' }}</v-icon>
      </v-btn>
    </template>
  </v-text-field>

<!-- Componenet for IE problems wit even @input -->
  <v-text-field
    v-else
    :outlined="!disabled"
    :filled="disabled"
    :value="inputValue"
    :label="label"
    :hint="hint"
    :hide-details="'auto'"
    @change="emitValue"
    :rules="rules"
    :disabled="disabled || hiddenData"
    v-bind:class="{ 'hiddenData': hiddenData }"
  >
   <template v-if="$slots.required" v-slot:prepend-inner>
      <slot name="required"></slot>
    </template>

    <template v-if="canHideData" v-slot:append>
      <v-btn
        class="button-eye"
        icon
        @click="toggleHiddenData"
      >
        <v-icon>{{ hiddenData ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
export default {
  props: {
    label: String,
    hint: String,
    placeholder: String,
    disabled: Boolean,
    initialValue: {
      required: false,
    },
    inputData: Object,
    rules: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data({ initialValue }) {
    return {
      visibleValue: initialValue,
      hiddenData: false,
      deletedData: false,
      copiedData: false,
      throttle: null,
      isModified: false,
      isInternetExplorer: (navigator.userAgent.indexOf('Trident/') > -1),
    };
  },
  created() {
    if (this.initialValue != null) {
      this.$emit('update:inputData', {
        value: this.initialValue,
      });
    }
    this.hiddenData = this.canHideData && typeof this.initialValue === 'string' && this.initialValue !== '';
    this.deletedData = this.canDeleteData && typeof this.initialValue === 'string' && this.initialValue !== '';
    this.copiedData = this.canCopyData && typeof this.initialValue === 'string' && this.initialValue !== '';
    this.throttle = this.$throttle((value) => {
      this.$emit('update:inputData', { value });
    }, 200);
  },
  computed: {
    canHideData() {
      const { hidden } = this.params;
      if (typeof hidden === 'undefined') {
        return false;
      }
      return typeof hidden === 'function' ? hidden() : (hidden === 'true');
    },
    canDeleteData() {
      const { deleted } = this.params;
      if (typeof deleted === 'undefined' || this.initialValue === '') {
        return false;
      }
      return typeof deleted === 'function' ? deleted() : (deleted === 'true');
    },
    canCopyData() {
      const { copied } = this.params;
      if (typeof copied === 'undefined') {
        return false;
      }
      return typeof copied === 'function' ? copied() : (copied === 'true');
    },
    inputValue() {
      let value = this.visibleValue;
      // if (this.params.isObfuscate && value != null && value !== '') {
      //   const startIndex = 0;
      //   const endIndex = value.length - (value.length > 5 ? 3 : 1);
      //   const asterisks = Array.from({
      //     length: endIndex - startIndex,
      //   }, () => '*').join('');
      //   value = `${asterisks}${value.substring(endIndex)}`;
      // }
      if (this.params.isObfuscate && !this.isModified && value != null && value !== '') {
        const startIndex = 0;
        const endIndex = value.length - (value.length > 5 ? 3 : 1);
        const asterisks = Array.from({
          length: endIndex - startIndex,
        }, () => '*').join('');
        value = `${asterisks}${value.substring(endIndex)}`;
      } else if (this.hiddenData && value != null && value !== '') {
        const startIndex = 0;
        const endIndex = value.length - (value.length > 5 ? 3 : 1);
        const asterisks = Array.from({
          length: endIndex - startIndex,
        }, () => '*').join('');
        value = `${asterisks}${value.substring(endIndex)}`;
      }
      return value;
    },
  },
  methods: {
    parseRegexRule(regexRule) {
      if (!regexRule) {
        return null;
      }

      if (regexRule instanceof RegExp) {
        return new RegExp(regexRule.source, regexRule.flags);
      }

      if (typeof regexRule === 'string') {
        const normalizedRule = regexRule.trim();
        const match = normalizedRule.match(/^\/(.*)\/([gimsuy]*)$/);

        if (match) {
          return new RegExp(match[1], match[2]);
        }

        return new RegExp(normalizedRule);
      }

      return null;
    },
    toggleHiddenData() {
      if (this.visibleValue !== '') {
        this.hiddenData = !this.hiddenData;
      }
    },
    deleteFieldData() {
      this.visibleValue = '';
      this.isModified = true;
      this.$emit('update:inputData', { value: '' });
      this.$root.$emit('deleteTextFormPerfil', { value: '' });
      this.deletedData = false;
    },
    copyFieldData() {
      this.visibleValue = this.initialValue;
      this.deletedData = true;
    },
    emitValue(value) {
      const { hiddenData, visibleValue } = this;
      const { limitEmail, maxLength } = this.params;

      this.isModified = true;

      if (this.params?.isEmpty && !value) {
        this.$root.$emit('deletePhoneContact', { });
      }

      if (this.params?.specificRules) {
        this.rules.push((value2) => {
          const rul = this.parseRegexRule(this.params.specificRules);
          const text = (value2 || value || '').split('@')[0];

          if (value2 == null || value2 === '') {
            return true;
          }

          if (rul && rul.test(text)) {
            return true;
          }

          return this.params?.errorMessage || 'El valor no cumple con el formato requerido';
        });
      }

      this.deletedData = true;
      if (this.params && limitEmail) {
        this.rules.push((value2) => {
          const emaillName = value.split('@')[0];
          return (
            value2 == null
            || value2 === ''
            || emaillName.length <= parseInt(maxLength, 10)
            || `La cuenta no puede tener más de ${maxLength} caracteres, excluyendo @juntadeandalucia.es`
          );
        });
      }
      if (!hiddenData && visibleValue !== value) {
        this.visibleValue = value;
        this.throttle(value);
      }
    },
  },
  beforeDestroy() {
    this.$emit('update:inputData', {});
  },
};
</script>

<style lang="scss" scoped>
  .button-eye, .button-delete, .button-copy {
    pointer-events: auto;
    margin-top: -5px;
  }
</style>

<style>
  .v-input--switch .v-input__slot {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
  .v-input--switch .v-input__slot .v-input--selection-controls__input {
    margin-left: .75em;
  }
</style>
